export default __webpack_public_path__ + "static/media/FD3.1fcb91df.png";